import { useState, useCallback } from "react";
import {
  createSponsor,
  updateSponsor,
  deleteSponsor,
  type CreateSponsorInput,
  type UpdateSponsorInput,
} from "../services/sponsorService";

export function useCreateSponsor() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const create = useCallback(async (input: CreateSponsorInput) => {
    setLoading(true);
    setError(null);
    try {
      const id = await createSponsor(input);
      return id;
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Create sponsor failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { create, loading, error };
}

export function useUpdateSponsor() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const update = useCallback(
    async (sponsorId: string, input: UpdateSponsorInput) => {
      setLoading(true);
      setError(null);
      try {
        await updateSponsor(sponsorId, input);
      } catch (err) {
        const e =
          err instanceof Error ? err : new Error("Update sponsor failed");
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { update, loading, error };
}

export function useDeleteSponsor() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const remove = useCallback(async (sponsorId: string) => {
    setLoading(true);
    setError(null);
    try {
      await deleteSponsor(sponsorId);
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Delete sponsor failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { remove, loading, error };
}
